import React, { useEffect, useState } from 'react';
import { Pagination } from '../../Pagination';
import DeleteFormPopup from './DeleteFormPopup';
import CreateNewFormPopup from './CreateNewFormPopup';
import SearchItemBlock from '../../../shared/SearchItemBlock';
import CreateNewFormButton from './CreateNewFormButton';
import DownloadFormsCsvButton from './DownloadFormsCsvButton';
import FormsList from './FormsList';
import FormTable from './FormTable';
import { formsStorage } from '../../../services/formsStorage';
import { useTranslation } from 'react-i18next';
import useWindowDimensions from '../../../hooks/useWindowDimension';
import RestoreItemPopup from '../../../shared/RestoreItemPopup';
import { formRestoreService } from '../../../services/formRestoreService';
import { useListViewMode } from '../../../shared/listView/useListViewMode';
import ListViewSwitcher from '../../../shared/listView/ListViewSwitcher';

const FormListTab = () => {
    const { i18n } = useTranslation();
    const { width } = useWindowDimensions();
    const { mode, setMode, isTableForcedOff } = useListViewMode('form');
    const [revision, setRevision] = useState(0);
    const [isLoading, setIsLoading] = useState(true);

    const notifyFormsList = () => {
        formsStorage.loadItems(() => setRevision((value) => value + 1), width);
    };

    useEffect(() => {
        const onChange = () => {
            setIsLoading(false);
            setRevision((value) => value + 1);
        };
        formsStorage.loadItems(onChange, width);
        formsStorage.registerFiltersChangingObserver(onChange);
        return () => {
            formsStorage.unRegisterFiltersChangingObserver(onChange);
            formsStorage.setPageNumber(1);
            formsStorage.changeDeletedItemsView(false);
        };
    }, []);

    const items = mode === 'table'
        ? formsStorage.getItems(true)
        : formsStorage.getItems();

    return (
        <>
            <SearchItemBlock
                itemsStorageService={formsStorage}
                placeholder={i18n.t('app.page.product.formSearch')}
                actions={
                    <>
                        <CreateNewFormButton />
                        <DownloadFormsCsvButton />
                        <ListViewSwitcher
                            mode={mode}
                            onChange={setMode}
                            disabled={isTableForcedOff}
                        />
                    </>
                }
            />
            {mode === 'table' ? (
                <FormTable key={`table-${revision}`} items={items} isLoading={isLoading} />
            ) : (
                <FormsList key={`tile-${revision}`} items={items} />
            )}
            {mode === 'tile' ? <Pagination itemsStorageService={formsStorage} /> : null}
            <DeleteFormPopup notifyFormsList={notifyFormsList}/>
            <CreateNewFormPopup />
            <RestoreItemPopup itemRestoreService={formRestoreService} notifyItemsList={notifyFormsList} />
        </>
    );
};

export default FormListTab;
